module.exports = __webpack_public_path__ + "b85b4078db8c1fd5b6a6440e42a56f37.svg";